import { stockRequestBody } from "./stockContext";
import { apiFetch } from "./apiFetch";

export async function fetchStockBarchartHoldingsWatchlists(serverUrl, stockSession) {
  const resp = await apiFetch(`${serverUrl}/listStockBarchartHoldingsWatchlists`, {
    method: "POST",
    body: JSON.stringify(stockRequestBody(stockSession)),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || data.error || "Failed to load Barchart watchlists");
  }
  return {
    savedWatchlists: Array.isArray(data.savedWatchlists) ? data.savedWatchlists : [],
    lastRefreshAt: data.lastRefreshAt ? String(data.lastRefreshAt) : "",
  };
}

export async function saveStockBarchartHoldingsWatchlist(
  serverUrl,
  stockSession,
  { name, barchartUrl, created_by }
) {
  const resp = await apiFetch(`${serverUrl}/saveStockBarchartHoldingsWatchlist`, {
    method: "POST",
    body: JSON.stringify(stockRequestBody(stockSession, { name, barchartUrl, created_by })),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || data.error || "Failed to save Barchart watchlist");
  }
  return data;
}

export async function updateStockBarchartHoldingsWatchlist(
  serverUrl,
  stockSession,
  { watchlistId, name, barchartUrl }
) {
  const resp = await apiFetch(`${serverUrl}/updateStockBarchartHoldingsWatchlist`, {
    method: "POST",
    body: JSON.stringify(stockRequestBody(stockSession, { watchlistId, name, barchartUrl })),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || data.error || "Failed to update Barchart watchlist");
  }
  return data;
}

export async function deleteStockBarchartHoldingsWatchlist(serverUrl, stockSession, watchlistId) {
  const resp = await apiFetch(`${serverUrl}/deleteStockBarchartHoldingsWatchlist`, {
    method: "POST",
    body: JSON.stringify(stockRequestBody(stockSession, { watchlistId })),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || data.error || "Failed to delete Barchart watchlist");
  }
  return data;
}
